import React, { useEffect, useState } from "react";
import { ITreatment } from "../types/clinic.types";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import bookUrl from "../../../../api/bookUrl";

interface Props {
  treatment: ITreatment | null; // null for 'Add', object for 'Edit'
  onClose: () => void;
  onSave: (treatment: ITreatment) => void;
}
interface Data {
  id: number | string;
  name: string;
  calories: string;
}

function createData(id: number | string, name: string, calories: string): Data {
  return { id, name, calories };
}
const DEFAULT_TREATMENT: Omit<ITreatment, "id" | "subTreatments"> = {
  treatmentId: "",
  localPrice: "",
  foreginPrice: "",
};

export const TreatmentFormModal: React.FC<Props> = ({
  treatment,
  onClose,
  onSave,
}) => {
  const [formData, setFormData] = useState(treatment || DEFAULT_TREATMENT);
  const isEditMode = !!treatment;
  console.log(treatment);
  
  const [rows, setRows] = useState<Data[]>([]);
  useEffect(() => {
    bookUrl
      .get("/bookingclinic/clinic/findBookClinicTreatment")
      .then((response: any) => {
        const formattedRows = response.data.data.map((item: any) =>
          createData(item._id, item.name, item.description)
        );
        setRows(formattedRows);
      })
      .catch(console.error);
  }, []);
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "number" ? parseFloat(value) || 0 : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
   console.log(treatment);
   
    if (isEditMode) {
      bookUrl
        .patch("/bookingclinic/clinic/updateBookTreatments", formData)
        .then((response) => {
          onSave(formData as ITreatment);
        })
        .catch((error) => {
          if (error.response?.status === 409) {
            alert("A treatment  already exists.");
          } else {
            console.error(error);
            alert("An unexpected error occurred.");
          }
        })
        .finally(() => {});
    } else { const errors = [];
    if (!formData.treatmentId) errors.push("Treatment is required.");
    if (
      !formData.localPrice ||
      isNaN(Number(formData.localPrice)) ||
      Number(formData.localPrice) < 0
    )
      errors.push("Local price must be a valid non-negative number.");
    if (
      !formData.foreginPrice ||
      isNaN(Number(formData.foreginPrice)) ||
      Number(formData.foreginPrice) < 0
    )
      errors.push("Foreign price must be a valid non-negative number.");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    const payload = {
      ...formData,
      localPrice: Number(formData.localPrice),
      foreginPrice: Number(formData.foreginPrice),
    };
      bookUrl
        .patch("/bookingclinic/clinic/createBookTreatments", payload)
        .then((response) => {
          onSave(formData as ITreatment);
        })
        .catch((error) => {
          if (error.response?.status === 409) {
            alert("A treatment  already exists.");
          } else {
            console.error(error);
            alert("An unexpected error occurred.");
          }
        })
        .finally(() => {});
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content modal-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h3>{isEditMode ? "Edit Treatment" : "Add New Treatment"}</h3>
            <button
              type="button"
              className="btn btn-icon modal-close-btn"
              onClick={onClose}
            >
              <CloseIcon />
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Treatment Name</label>

              <select
                name="treatmentId"
                value={formData.treatmentId}
                onChange={handleChange}
                required
              >
                 <option value={""}>
                    select
                  </option>
                {rows.map((row) => (
                  <option key={row.id} value={row.id}>
                    {row.name + " - " + (row?.calories ?? "")}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label> Consultiing Normal Price LKR</label>
              <input
                type="number"
                name="localPrice"
                value={formData.localPrice}
                onChange={handleChange}
                placeholder="Enter price in LKR"
              />
            </div>
            <div className="form-group">
              <label> Consultiing Price for Foreigners USD</label>
              <input
                type="number"
                name="foreginPrice"
                value={formData.foreginPrice}
                onChange={handleChange}
                placeholder="Enter price in USD"
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
